import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { throttle } from '@/composables/useThrottle';

export const useBrowserStore = defineStore('browserStore', () => {
  const viewport = ref({
    width: 0,
    height: 0,
  });

  const userAgent = ref('');
  const isBot = ref(false);

  const updateViewport = throttle(() => {
    const newWidth = window.innerWidth;
    const newHeight = window.innerHeight;
    if (viewport.value.width !== newWidth || viewport.value.height !== newHeight) {
      viewport.value = {
        width: newWidth,
        height: newHeight,
      };
    }
  }, 1000);

  const initializeBrowserData = () => {
    updateViewport();
    userAgent.value = navigator.userAgent;
    isBot.value = /bot|crawler|spider|crawling/i.test(userAgent.value);
    window.addEventListener('resize', updateViewport);
  };

  type DeviceSize = 'mobile' | 'tablet' | 'desktop';
  const isViewportReady = computed(() => viewport.value.width > 0);

  const deviceSize = computed<DeviceSize | null>(() => {
    const { width } = viewport.value;
    if (!width) return null;
    if (width < 768) return 'mobile';
    if (width < 991) return 'tablet';
    return 'desktop';
  });

  return {
    viewport,
    userAgent,
    isBot,
    deviceSize,
    initializeBrowserData,
    isViewportReady,
  };
});
